import React from 'react';
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, XAxis, YAxis } from 'recharts';

const MonthlyContractSummary = ({ title = {} }) => {
  return (
    <div style={{ width: '100%', background: '#fff', borderRadius: 10 }} className="mt-3">
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={title} margin={{ top: 10, right: 20, left: 0 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month" />
          <YAxis />
          <Legend wrapperStyle={{ marginTop: 5, marginBottom: -25 }} />
          <Line
            type="monotone"
            dataKey="finished"
            stroke="#f44336"
            strokeWidth={2}
            dot={{ fill: '#f44336' }}
            activeDot={{ r: 6 }}
            name="Finiquitados"
          />
          <Line
            type="monotone"
            dataKey="contracted"
            stroke="#388e3c"
            strokeWidth={2}
            dot={{ fill: '#82ca9d' }}
            activeDot={{ r: 6 }}
            name="Contratados"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};
export default MonthlyContractSummary;
